import cx from 'classnames';
import React from 'react';
import type { Optional } from '@gov-nx/core/types';

export interface TabsNavProps {
	children: React.ReactNode;
	className?: string;
	moreBadges?: Optional<boolean>;
	wcagLabel?: string;
	customClasses?: string;
}

export const TabsNav = ({
	children,
	className,
	wcagLabel,
	customClasses,
}: TabsNavProps) => (
	<div
		className={cx('gov-tabs gov-tabs--m', className)}
		data-type="text">
		<nav
			aria-label={wcagLabel}
			className="gov-tabs__tabs">
			<ul
				role="tablist"
				className={cx('gov-tabs__list', customClasses)}>
				{children}
			</ul>
		</nav>
	</div>
);
